import type { FC, ReactElement, ReactNode } from 'react';
import { Children, cloneElement } from 'react';

/**
 * A component that adds the Braze Tag Manager ID to its children.
 *
 * @param {string} id
 * @param {ReactNode} children
 * @returns {ReactNode}
 */
type TagManagerIdProps = {
  id: string;
  children: ReactNode;
};

export const TagManagerId: FC<TagManagerIdProps> = ({ id, children }) => {
  try {
    if (Children.only(children)) {
      return cloneElement(children as ReactElement, {
        'data-tm-id': id,
      });
    }
  } catch (e) {
    console.warn(
      'TagManagerId can only accept one React element as children',
      e
    );
    return children;
  }
  return children;
};
